import gql from "graphql-tag";

export const PAGE_FOR_STATIC_PAGE = gql`
  query pageForStaticPage($id: ID, $slug: String) {
    #https://github.com/velymonkeys/velymonkeys/blob/bc1e32571d78e9a9242d7e5d0b539c8d199da52b/templates/page/details.html#L43
    page(id: $id, slug: $slug) {
      seoTitle
      title
      seoDescription
      # to make url: /en/page/{slug}/
      slug
      isPublished
      isVisible
      publicationDate
      content
    }
  }
`;

